// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.1_esbuild@0.28.1_/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.1_esbuild@0.28.1_/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.TerritoryInSearch-wrapper {
  padding: 24px 32px;
  border-radius: var(--border_radius_default);
  background-color: var(--color_neutral_200);
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  column-gap: 8px;
  height: 108px;
  cursor: pointer;
}
.TerritoryInSearch-wrapper .titlesSection {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.TerritoryInSearch-wrapper .titlesSection p {
  font-size: 16px;
  color: var(--color_neutral_900);
}
.TerritoryInSearch-wrapper .titlesSection label {
  color: var(--color_neutral_500);
  font-size: 12px;
}
.TerritoryInSearch-wrapper .metricSection {
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.TerritoryInSearch-wrapper .metricSection p {
  color: var(--color_neutral_800);
  font-size: 14px;
  text-align: center;
}
.TerritoryInSearch-wrapper .metricSection label {
  color: var(--color_neutral_500);
  font-size: 12px;
  text-align: center;
}
.TerritoryInSearch-wrapper:hover {
  background-color: var(--color_primary_100);
}
.TerritoryInSearch-wrapper:hover .titlesSection p {
  color: var(--color_primary_500);
}`, "",{"version":3,"sources":["webpack://./src/pages/SearchTerritoriesPage/components/WinninTopicsTab/components/TerritoryInSearch/index.scss"],"names":[],"mappings":"AAAA;EACE,kBAAA;EACA,2CAAA;EACA,0CAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,eAAA;EACA,aAAA;EACA,eAAA;AACF;AACE;EACE,aAAA;EACA,sBAAA;EACA,8BAAA;AACJ;AACI;EACE,eAAA;EACA,+BAAA;AACN;AAEI;EACE,+BAAA;EACA,eAAA;AAAN;AAIE;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;AAFJ;AAII;EACE,+BAAA;EACA,eAAA;EACA,kBAAA;AAFN;AAKI;EACE,+BAAA;EACA,eAAA;EACA,kBAAA;AAHN;AAOE;EACE,0CAAA;AALJ;AAQM;EACE,+BAAA;AANR","sourcesContent":[".TerritoryInSearch-wrapper {\n  padding: 24px 32px;\n  border-radius: var(--border_radius_default);\n  background-color: var(--color_neutral_200);\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  column-gap: 8px;\n  height: 108px;\n  cursor: pointer;\n\n  .titlesSection {\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n\n    p {\n      font-size: 16px;\n      color: var(--color_neutral_900);\n    }\n\n    label {\n      color: var(--color_neutral_500);\n      font-size: 12px;\n    }\n  }\n\n  .metricSection {\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n\n    p {\n      color: var(--color_neutral_800);\n      font-size: 14px;\n      text-align: center;\n    }\n\n    label {\n      color: var(--color_neutral_500);\n      font-size: 12px;\n      text-align: center;\n    }\n  }\n\n  &:hover {\n    background-color: var(--color_primary_100);\n\n    .titlesSection {\n      p {\n        color: var(--color_primary_500);\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
